export default "__VITE_ASSET__OrSwLDF1__"